import { render, staticRenderFns } from "./ConfirmStatusDialog.vue?vue&type=template&id=bf0cb1a2&"
import script from "./ConfirmStatusDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmStatusDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports